import {Navigate} from "react-router-dom";

const PrivateRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
    const token = localStorage.getItem("token");

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;